var _effectorFileName = "/builds/gmini/front-ui-kit/src/SelectByGroupsMultiple/components/RenderOptions/RenderOptions.tsx";
import { useCallback, useEffect, useState } from 'react';
import { isFieldIncludedToSearch } from '../../../utils/isFieldIncludedToSearch';
import { DEFAULT_MESSAGE_EMPTY_LIST } from '../../../Select/constants';
import { OptionWrapper, RenderOption } from '../../../SelectMultiple/components';
import { createOptionId } from '../../../SelectByGroups/components/RenderOptions/createOptionId';
import { GroupTitle } from '../../../SelectByGroups/components/RenderOptions/RenderOptions.styled';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RenderOptions = ({
  inputRef,
  groups,
  loading,
  emptyOptionListMessage,
  renderOption,
  onSelect,
  value,
  onBlurHandler,
  inputValue,
  getOptionLabel,
  renderLoading,
  groupTitleStyled,
  optionDataTestIdPrefix
}) => {
  const [groupList, setGroupList] = useState(groups);
  const [focusedOptionId, setFocusedOptionId] = useState('0');
  const isOptionIncludedToSearch = useCallback(option => isFieldIncludedToSearch(getOptionLabel(option), inputValue), [getOptionLabel, inputValue]);
  const onMouseEnterOption = useCallback(id => setFocusedOptionId(id), []);
  const isSelectedOption = useCallback(item => value.some(valueItem => JSON.stringify(item) === JSON.stringify(valueItem)), [value]);
  useEffect(() => {
    if (!groups) {
      return;
    }

    let nextGroupList = [];

    if (value && value.some(valueItem => getOptionLabel(valueItem) === inputValue)) {
      nextGroupList = groups;
    } else {
      nextGroupList = groups.filter(group => isFieldIncludedToSearch(group.label, inputValue) || group.options.some(isOptionIncludedToSearch)).map(group => ({ ...group,
        options: group.options.filter(isOptionIncludedToSearch)
      }));
    }

    setGroupList(nextGroupList);
  }, [getOptionLabel, groups, inputValue, isOptionIncludedToSearch, value]);

  if (loading) {
    return renderLoading ? /*#__PURE__*/_jsx(_Fragment, {
      children: renderLoading()
    }) : /*#__PURE__*/_jsx(OptionWrapper, {
      onClick: () => {
        var _inputRef$current;

        return (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
      },
      disabled: true,
      children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..."
    });
  }

  if (groupList && groupList.length > 0) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: groupList.filter(({
        options
      }) => options.length).map((group, groupIdx) => /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(GroupTitle, {
          additionalStyled: groupTitleStyled,
          children: group.label
        }), group.options.map((option, optionIdx) => {
          const active = isSelectedOption(option);
          const id = createOptionId(groupIdx, optionIdx);
          return renderOption ? renderOption({
            option,
            id,
            hover: focusedOptionId === id,
            onClose: onBlurHandler,
            inputValue,
            active
          }) : /*#__PURE__*/_jsx(RenderOption, {
            option: option,
            hover: focusedOptionId === id,
            onSelect: onSelect,
            onMouseEnter: () => onMouseEnterOption(id),
            active: active,
            getOptionLabel: getOptionLabel,
            isHighlightEnabled: !value,
            highlightingPattern: inputValue,
            "data-test-id": optionDataTestIdPrefix
          }, id);
        })]
      }, group.label))
    });
  }

  return /*#__PURE__*/_jsx(OptionWrapper, {
    onClick: () => {
      var _inputRef$current2;

      return (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.focus();
    },
    disabled: true,
    children: emptyOptionListMessage || DEFAULT_MESSAGE_EMPTY_LIST
  });
};